module.exports = __webpack_public_path__ + "static/img/6-2-1.96b23ee8.jpg";